import { render, staticRenderFns } from "./FooterActions.vue?vue&type=template&id=0f4fbedc"
import script from "./FooterActions.vue?vue&type=script&lang=js"
export * from "./FooterActions.vue?vue&type=script&lang=js"
import style0 from "./FooterActions.vue?vue&type=style&index=0&id=0f4fbedc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports